import a, { css as i } from "styled-components";
import { getAsNumber as n } from "../../../utils/getAsNumber.es.js";
const d = a.div.withConfig({
  displayName: "NameAvatarContainer",
  componentId: "sc-1qu7luv-0"
})([""]), m = a.p.withConfig({
  displayName: "NameAvatarText",
  componentId: "sc-1qu7luv-1"
})(["color:var(--color-neutral-25);display:inline-block;text-decoration:none;"]), t = {
  sm: "var(--size-24)",
  md: "var(--size-32)",
  lg: "var(--size-40)"
}, l = a.div.withConfig({
  displayName: "NameAvatar",
  componentId: "sc-1qu7luv-2"
})(["align-items:center;background-color:var(--color-components-sidenav-avatar-bg);border-radius:", ";border-radius:var(--size-border-radius-circle);color:var(--color-components-sidenav-icon-fg);display:flex;font-weight:600;justify-content:center;text-decoration:none;", " text-transform:uppercase;"], ({
  rounded: e
}) => e ? "var(--size-border-radius-circle)" : "var(--size-border-radius-md)", ({
  size: e
}) => {
  const o = n(e), r = t[e] || (o ? `${o}px` : t.md);
  return i(["font-size:calc(", " / 3);min-height:", ";min-width:", ";width:", ";"], r, r, r, r);
});
export {
  l as NameAvatar,
  d as NameAvatarContainer,
  m as NameAvatarText
};
//# sourceMappingURL=style.es.js.map
